import * as gxConst from "@/api/http/gx/gxConst";
import * as gxRequest from "@/api/http/gx/gxBase";
import Http from "@/api/http/fetch";
import {sendGXError, sendGXSuccess} from "@/utils/analytics";
/**
 * GX 的登陆
 * @param value
 */
export const login = (...value: any[]) => {
  return new Promise(async (resolve, reject) => {
    try {
      const masterId = value[0];
      const userId = value.length > 1 ? value[1] : value[0];
      const userInfo: any = {
        master_id: masterId.toString(),
        user_id: userId.toString()
      };
      const params = { user_info: userInfo };
      const result = await gxRequest.post(
        gxConst.kGetXApiPathUserLogin(userInfo.master_id),
        params
      );
      sendGXSuccess("login");
      console.log("denglu后的状态", result);
      resolve(result);
    } catch (error) {
      sendGXError(error, 'login');
      reject(error);
    }
  });
};

/**
 * 关联账户
 * @param paramsData
 */
export const linkAccount = (paramsData: any) => {
  return new Promise(async (resolve, reject) => {
    try {
      const { userId, masterId, insUserInfo } = paramsData;
      const { username, profile_pic_url } = insUserInfo;
      const userInfo: any = {
        master_id: masterId.toString(),
        user_id: userId.toString(),
        username,
        profile_pic_url
      };
      const params = { user_info: userInfo };
      const result = await gxRequest.post(
        gxConst.kGetXApiPathUserLogin(userInfo.master_id),
        params
      );
      sendGXSuccess("linkAccount");
      resolve(result);
    } catch (error) {
      sendGXError(error, 'linkAccount');
      console.log("linkAccount error:", error);
      reject(error);
    }
  });
};

/**
 * 转移账户
 * @param value
 */
export const transferAccount = (...value: any[]) => {
  return new Promise(async (resolve, reject) => {
    try {
      const masterId = value[0];
      const userId = value.length > 1 ? value[1] : value[0];
      const userInfo: any = {
        master_id: masterId.toString(),
        user_id: masterId.toString()
      };
      const params = { user_info: userInfo, old_user_id: userId.toString() };
      const result = await gxRequest.post(
        gxConst.kGetXApiPathUserLogin(userInfo.master_id),
        params
      );
      sendGXSuccess("transferAccount");
      resolve(result);
    } catch (error) {
      sendGXError(error, 'transferAccount');
      reject(error);
    }
  });
};

/**
 * device id => idfa
 * @param oldUserId
 * @param newUerId
 * @param oldPlatform
 * @param newPlatform
 */
export const transferMasterAccount = (
  oldUserId: string | number,
  newUerId: string | number,
  oldPlatform: string,
  newPlatform: any = null
) => {
  return new Promise(async (resolve, reject) => {
    try {
      const params: any = {
        old_user_id: oldUserId.toString(),
        dest_user_id: newUerId.toString(),
        old_platform: oldPlatform
      };
      if (newPlatform) {
        params.dest_platform = newPlatform;
      }
      // const params = { user_info: userInfo, old_user_id: userId.toString() };
      const result = await gxRequest.post(
        gxConst.kGetXApiTransferMasterAccount,
        params
      );
      sendGXSuccess("transferMasterAccount");
      resolve(result);
    } catch (error) {
      sendGXError(error, 'transferMasterAccount');
      reject(error);
    }
  });
};

/**
 * 通过用户的id获取user_info
 * @param userId
 */
export const getUserInfoById = (userId: string | number) => {
  return new Promise(async (resolve, reject) => {
    try {
      const result = await gxRequest.get(gxConst.kGetXApiPathUserInfo(userId));
      sendGXSuccess("getUserInfoById");
      resolve(result);
    } catch (error) {
      sendGXError(error, 'getUserInfoById');
      reject(error);
    }
  });
};

/**
 * 通过用户的id获取user_info
 * @param userId
 */
export const getServiceList = (deviceId: string) => {
  return new Promise(async (resolve, reject) => {
    try {
      const info = {
        master_id: deviceId
      };
      const result = await gxRequest.get(gxConst.kGetXApiPathServiceList, info);
      sendGXSuccess("getServiceList");
      resolve(result);
    } catch (error) {
      sendGXError(error, 'getServiceList');
      console.log("getServiceList error", error);
      reject(error);
    }
  });
};

/**
 * 解除子账号的关联
 * @param value
 */
export const disconnectUser = (...value: any[]) =>
  new Promise(async (resolve, reject) => {
    try {
      const master_id = value[0];
      const user_id = value.length > 1 ? value[1] : value[0];
      console.log("disconnectUser user_id", value);
      const params = {
        user_info: {
          master_id: master_id.toString(),
          user_id: user_id.toString()
        }
      };
      const result = await gxRequest.post(
        gxConst.kGetXApiPathUserDisconnect(master_id),
        params
      );
      sendGXSuccess("disconnectUser");
      resolve(result);
    } catch (error) {
      sendGXError(error, 'disconnectUser');
      reject(error);
    }
  });

export const setUserPaymentSwitcher = (master_id: any, paymentSwitcher: any) =>
  new Promise(async (resolve, reject) => {
    try {
      const info = {
        user_info: {
          master_id: `${master_id}`,
          user_id: `${master_id}`,
          payment_switcher: `${paymentSwitcher}`
        }
      };
      const res = await gxRequest.post(
        gxConst.kGetXApiPathSetPaymentSwitcher(master_id),
        info
      );
      sendGXSuccess("setUserPaymentSwitcher");
      resolve(res);
    } catch (error) {
      sendGXError(error, 'setUserPaymentSwitcher');
      reject(error);
    }
  });

// /api/v2/user/:master_id/daily/confirm
export const dailyCheckIn = (master_id: any) =>
  new Promise(async (resolve, reject) => {
    try {
      const timezoneNum = -(new Date().getTimezoneOffset() / 60);
      const timezoneStr = timezoneNum.toString();
      let timezoneResult: string;
      if (timezoneNum > 9 || timezoneNum < -9) {
        if (timezoneStr.length > 2) {
          timezoneResult = timezoneStr + "00";
        } else {
          timezoneResult = "+" + timezoneStr + "00";
        }
      } else {
        const arr = timezoneStr.split("");
        if (timezoneStr.length > 1) {
          timezoneResult = arr[0] + "0" + arr[1] + "00";
        } else {
          timezoneResult = "+0" + timezoneStr + "00";
        }
      }
      const params = {
        timezone: timezoneResult,
        // timezone: -480,
        user_info: {
          master_id: master_id.toString()
        }
      };
      const result = await gxRequest.post(
        gxConst.kGetXApiPathCheckIn(master_id),
        params
      );
      sendGXSuccess("dailyCheckIn");
      resolve(result);
    } catch (error) {
      sendGXError(error, 'dailyCheckIn');
      reject(error);
    }
  });

// /api/v1/offer/:user_id/redeem
export const redeem = (master_id: any, token: any, can_be_double: any) =>
  new Promise(async (resolve, reject) => {
    try {
      const params = {
        redeem_token: token,
        user_info: {
          master_id: master_id.toString()
        },
        double: can_be_double
      };
      const result = await gxRequest.post(
        gxConst.kGetXApiPathRedeem(master_id),
        params
      );
      sendGXSuccess("redeem");
      resolve(result);
    } catch (error) {
      sendGXError(error, 'redeem');
      reject(error);
    }
  });

export const getRecommendation = (kind: any) =>
  new Promise(async (resolve, reject) => {
    try {
      const params = {
        kind
      };
      const result = await gxRequest.get(
        gxConst.kGetXApiGetRecommendation,
        params
      );
      sendGXSuccess("getRecommendation");
      resolve(result);
    } catch (error) {
      sendGXError(error, 'getRecommendation');
      reject(error);
    }
  });

export const casino = (master_id: any, way: string, game: string) =>
  new Promise(async (resolve, reject) => {
    try {
      const params = {
        user_info: {
          master_id: master_id.toString()
        },
        way,
        game
      };
      const result = await gxRequest.post(gxConst.kGetXApiCasino, params);
      sendGXSuccess("casino");
      resolve(result);
    } catch (error) {
      sendGXError(error, 'casino');
      reject(error);
    }
  });

export const checkFreeFollowers = (master_id: any, user_id: any) =>
  new Promise(async (resolve, reject) => {
    try {
      const params = {
        master_id,
        user_id
      };
      const result = await gxRequest.post(
        gxConst.kGetXApiGetCheckFreeFollowers,
        params
      );
      sendGXSuccess("checkFreeFollowers");
      resolve(result);
    } catch (error) {
      sendGXError(error, 'checkFreeFollowers');
      reject(error);
    }
  });

export const deliverFreeFollowers = (
  master_id: any,
  user_id: any,
  resource: any
) =>
  new Promise(async (resolve, reject) => {
    try {
      const params = {
        master_id,
        user_id,
        resource
      };
      const result = await gxRequest.post(
        gxConst.kGetXApiGetDeliverFreeFollowers,
        params
      );
      sendGXSuccess("deliverFreeFollowers");
      resolve(result);
    } catch (error) {
      sendGXError(error, 'deliverFreeFollowers');
      reject(error);
    }
  });

export const advertisementAct = (
  master_id: any,
  platform: any,
  ad_type: any
) =>
  new Promise(async (resolve, reject) => {
    try {
      const params = {
        master_id,
        platform,
        ad_type
      };
      const result = await gxRequest.post(
        gxConst.kGetXApiAdvertisementAct,
        params
      );
      sendGXSuccess("advertisementAct");
      resolve(result);
    } catch (error) {
      sendGXError(error, 'advertisementAct');
      reject(error);
    }
  });

export const advertisementList = (
  master_id: any,
  platform: any,
  ad_types: any
) =>
  new Promise(async (resolve, reject) => {
    try {
      const params = {
        master_id,
        platform,
        ad_types
      };
      const result = await gxRequest.get(
        gxConst.kGetXApiAdvertisementList,
        params
      );
      sendGXSuccess("advertisementList");
      resolve(result);
    } catch (error) {
      sendGXError(error, 'advertisementList');
      reject(error);
    }
  });
